import { render } from "./NeuronHero.vue?vue&type=template&id=a3400126&scoped=true"
import script from "./NeuronHero.vue?vue&type=script&lang=js"
export * from "./NeuronHero.vue?vue&type=script&lang=js"

import "./NeuronHero.vue?vue&type=style&index=0&id=a3400126&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3400126"]])

export default __exports__